// The header search's tag results, pure (no network, no React), so a test can import them;
// tagSearch.js asks the database and uses these. See tagSearch.js for what they're for.
import * as f from './format.js'

// "The Property Accelerator, Group 2 recording, 27 Sep"; a recording for every group: "The Property
// Accelerator, recording, 27 Sep"
export function tagWhere(row) {
  const date = row.recorded_on ? f.dayMonth(f.calendarDay(row.recorded_on)) : null
  const what = row.cohort_name ? `${row.cohort_name} recording` : 'recording'
  return [row.product_name, what, date].filter(Boolean).join(', ')
}

// hub.search_recordings's rows -> [{ label, where, href }], 1 per matched tag, newest recording first
export function tagResults(rows) {
  const out = []
  const seen = new Set()
  for (const r of rows || []) {
    if (!r?.recording_key || !r.product_path) continue
    for (const tag of r.matched_tags || []) {
      const where = tagWhere(r)
      const key = `${tag.toLowerCase()}|${where}`
      if (seen.has(key)) continue
      seen.add(key)
      out.push({ label: tag, where, href: `${r.product_path}/${r.recording_key}` })
    }
  }
  return out
}

// The Library's own results first, then the tags', without the same line twice, at most limit
export function mergeResults(local, tags, limit) {
  const out = []
  const seen = new Set()
  for (const r of [...(local || []), ...(tags || [])]) {
    const key = `${r.label}|${r.where}`
    if (seen.has(key)) continue
    seen.add(key)
    out.push(r)
    if (out.length >= limit) break
  }
  return out
}
